import React from 'react';
import { Typography } from 'antd';
import AlumlyBreadCrumb, { PathT } from '../../../components/AlumlyBreadCrumb';
import { RouteNameEnum } from '../../../enums/routeName';
import FormFeaturedContent from '../components/FormFeaturedContent';

const CreateFeaturedContent: React.FC = () => {
  const path: PathT[] = [
    { label: 'Featured Contents', value: RouteNameEnum.featuredContent.index },
    { label: 'Create featured content', value: RouteNameEnum.featuredContent.create },
  ];

  return (
    <div>
      <AlumlyBreadCrumb path={path} />
      <Typography.Title level={4} style={{ margin: 0 }}>Create Featured Content</Typography.Title>
      <FormFeaturedContent mode="create" />
    </div>
  );
};

export default CreateFeaturedContent;
